import { getTotalValue, } from "@bracket/contractor-next/brktETH";
import { assetToUsd, } from "@utils";
import { wagmiConfig as config } from "@wagmiconfig";
import type { AssetUSD, } from "@bracket/types";
import { WEI, } from "@bracket/blocksmith";
import { getTokenDefinition, } from "@bracket/chainography";


export const getBrktTVL = async (): Promise<AssetUSD> => {

	try {

		const value = await getTotalValue({ config, });
		const usd = await assetToUsd(value, { symbol: "BRKTETH", chainId: 1, });

		return {
			usd,
			asset: await WEI.from(value, getTokenDefinition({ symbol: "BRKTETH", chainId: 1, })),
		}

	}
	catch(err) {

		console.warn("failed gaining brkt tvl", err);

		return {
			usd: 0,
			asset: WEI.fromSync(0),
		}

	}
}
